// extracted by mini-css-extract-plugin
export var details = "_kk-0";
export var inspectorPopover = "_kk-1";